import { ApiClient } from "../../ApiClient"
import { GetMenuResponse } from "../schema/GetMenuResponse"
import { Menu } from "@/@types"
import { _menus } from "@/_mock/_home"
import { mapMenu } from '../../mappers/menuMapper';


export const getMenu = async (): Promise<Menu[]> => {

  const client = ApiClient.getInstance()
  const response = await client.get<GetMenuResponse>("home/menu")

  const menuItems = response.data.map(mapMenu)

  // Sort industries by order within each menu item
  menuItems.forEach(menuItem => {
    if (menuItem.industries && menuItem.industries.length > 0) {
      menuItem.industries.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }
  });

  return menuItems

}